import React from 'react';
import QRCode from '../../QRCode';
import MobileNumberButton, {
  MobileNumberButtonFormValues,
} from '../../Form/inputV3/MobileNumberButton';
import { LinkV2 } from '../../LinkV2';
import {
  Container,
  TopSection,
  LeftColumn,
  RightColumn,
  Text,
  Terms,
  QRContainer,
  ImgContainer,
  Header,
} from './AppDownloadDesktop.styles';

import Modal from '../index';
import type { ModalProps } from '../Modal';

const HEADER_ID = 'downloadAppHed';

export type AppDownloadDesktopProps = {
  /**
   * The modal title
   */
  hed: string;
  /**
   * The image in the left column
   */
  imgSrc: string;
  /**
   * The alt text for the image in the left column
   */
  imgAlt: string;
  /**
   * The action to be taken when hitting "send" on the mobile input
   */
  onSubmit: (values: MobileNumberButtonFormValues) => Promise<void>;
  /**
   * The src for the QR code deeplink SVG.  Get from Zola UI.
   */
  qrCode: string;
};

export const AppDownloadDesktopDisplay = ({
  hed,
  imgSrc,
  imgAlt,
  onSubmit,
  qrCode,
}: AppDownloadDesktopProps): JSX.Element => {
  const focusOnCloseButton = () => {
    document.getElementById('zCloseModal')?.focus();
  };
  return (
    <Container>
      <TopSection>
        <LeftColumn>
          <Header id={HEADER_ID}>{hed}</Header>
          <ImgContainer src={imgSrc}>
            <span role="img" aria-label={imgAlt} />
          </ImgContainer>
        </LeftColumn>
        <RightColumn>
          <Text>To download, scan the QR code with your phone...</Text>
          <QRContainer>
            <QRCode src={qrCode} />
          </QRContainer>
          <Text>
            ...or enter your mobile number and we&apos;ll text you a one-time download link.
          </Text>
          <MobileNumberButton
            onSubmit={(...args) => {
              focusOnCloseButton();
              return onSubmit(...args);
            }}
          />
        </RightColumn>
      </TopSection>
      <div>
        <Terms>
          By submitting this form, you agree to receive a one-time automated personalized marketing
          text message from Zola at the cell number used when signing up. Consent is not a condition
          of any purchase. Reply HELP for help and STOP to cancel. Msg and data rates may apply.
          View{' '}
          <LinkV2 href="https://attnl.tv/t/yVv" inline rel="noopener noreferrer" target="_blank">
            Terms
          </LinkV2>{' '}
          &amp;{' '}
          <LinkV2 href="https://attnl.tv/p/yVv" inline rel="noopener noreferrer" target="_blank">
            Privacy
          </LinkV2>
          .
        </Terms>
      </div>
    </Container>
  );
};

export type AppDownloadDesktopModalProps = AppDownloadDesktopProps &
  Omit<ModalProps, 'dialogHeadingId'>;

export const AppDownloadDesktopModal = ({
  onClose,
  rootId,
  triggerRef,
  ...appDownloadDesktopProps
}: AppDownloadDesktopModalProps): JSX.Element => (
  <Modal dialogHeadingId={HEADER_ID} rootId={rootId} onClose={onClose} triggerRef={triggerRef}>
    <AppDownloadDesktopDisplay {...appDownloadDesktopProps} />
  </Modal>
);

export default AppDownloadDesktopModal;
